import { render, staticRenderFns } from "./AiAssistantWidget.vue?vue&type=template&id=3f85c9fe&scoped=true&"
import script from "./AiAssistantWidget.vue?vue&type=script&lang=js&"
export * from "./AiAssistantWidget.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantWidget.vue?vue&type=style&index=0&id=3f85c9fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85c9fe",
  null
  
)

export default component.exports